// extracted by mini-css-extract-plugin
export default {"iconBox":"HyOZxcS5l4SMTOoz5_of"};